import { combineReducers } from 'redux';
import fuse from './fuse';
import auth from 'auth/store/reducers/index';
import company from './company.reducer';

const rootReducer = combineReducers({
  auth,
  fuse,
  company,
});

export default rootReducer;